export default __webpack_public_path__ + "static/media/KheshattaCity.5396298c.jpg";